import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "product-assets" };
const _hoisted_2 = { class: "product-assets__title" };
const _hoisted_3 = { class: "product-assets__list" };
const _hoisted_4 = ["href"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductAssets',
    props: {
        assets: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('product.assets')), 1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.assets, (asset, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            class: "product-assets__item"
                        }, [
                            _createElementVNode("a", {
                                href: asset.source,
                                target: "_blank",
                                class: "product-assets__link"
                            }, _toDisplayString(asset.title), 9, _hoisted_4)
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
});
